<template>
  <div class="bar-box">
    <div @click="tab(1)" :class="type == 1 ? 'ac' : ''" class="baritem">
      <div>
        <img
          :src="type == 1 ? './assets/icon/icon_index_ac.png' : './assets/icon/icon_index.png'"
          alt=""
        />
      </div>
      首页
    </div>
    <div @click="tab(2)" :class="type == 2 ? 'ac' : ''" class="baritem">
      <div>
        <img
          :src="type == 2 ? './assets/icon/icon_more_ac.png' : './assets/icon/icon_more.png'"
          alt=""
        />
      </div>
      其余功能
    </div>
    <div @click="tab(3)" :class="type == 3 ? 'ac' : ''" class="baritem">
      <div>
        <img
          :src="type == 3 ? './assets/icon/icon_user_ac.png' : './assets/icon/icon_user.png'"
          alt=""
        />
      </div>
      我的
    </div>
  </div>
</template>
<script>
export default {
  name: 'tabbar',
  components: {},
  props: ['type'],
  data() {
    return {};
  },
  computed: {},
  methods: {
    tab(type) {
      switch (type) {
        case 1:
          this.$router.replace({ path: '/index' });
          break;
        case 2:
          this.$router.replace({ path: '/other' });
          break;
        case 3:
          this.$router.replace({ path: '/personal' });
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.bar-box {
  position: absolute;
  bottom: 0;
  height: 54px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: white;
  box-sizing: content-box;
  box-shadow: 0px -1px 6px 0px rgba(238, 238, 238, 0.6);
  padding-bottom: env(safe-area-inset-bottom);
  z-index: 9;
  justify-content: space-around;
  .baritem {
    flex: 1;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #c8c8c8;
    line-height: 10px;
    text-align: center;
    justify-content: center;
    cursor: pointer;
    img {
      width: 24px;
      height: 24px;
      margin-bottom: 4px;
    }
  }
  .baritem.ac {
    color: #222222;
  }
}
</style>
